module.exports = __webpack_public_path__ + "img/1fab37f.jpg";